import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Wordmark } from "./Logo";
import { CONTACT, NAV } from "@/lib/content";
import { EASE } from "./motion";

const Col = ({ title, children }) => (
  <div>
    <p className="mb-5 font-mono text-[11px] uppercase tracking-[0.25em] text-cream/50">{title}</p>
    <div className="space-y-2.5 font-body text-sm text-cream/80">{children}</div>
  </div>
);

export const Footer = () => (
  <footer data-testid="site-footer" className="relative overflow-hidden border-t border-cream/10 bg-skaris-ink pt-20">
    <div className="mx-auto grid max-w-[1440px] gap-12 px-6 md:grid-cols-12 md:px-10">
      <div className="md:col-span-5">
        <p className="max-w-sm font-display text-3xl font-medium leading-tight text-cream">
          Built for your business. <span className="text-cream/50">Engineered to perform.</span>
        </p>
      </div>
      <div className="grid grid-cols-2 gap-10 md:col-span-7 md:grid-cols-3">
        <Col title="Sitemap">
          {NAV.map((n) => (
            <Link key={n.to} to={n.to} data-testid={`footer-nav-${n.label.toLowerCase()}`} className="link-underline block w-fit">{n.label}</Link>
          ))}
        </Col>
        <Col title="Contact">
          <a href={`mailto:${CONTACT.email}`} data-testid="footer-email" className="link-underline block w-fit break-all text-[13px]">{CONTACT.email}</a>
          <a href={CONTACT.phoneHref} data-testid="footer-phone" className="link-underline block w-fit">{CONTACT.phone}</a>
          {CONTACT.address.map((l) => <span key={l} className="block text-cream/60">{l}</span>)}
        </Col>
        <Col title="Social">
          {CONTACT.socials.map((s) => (
            <a key={s.label} href={s.href} data-testid={`footer-social-${s.label.split(" ")[0].toLowerCase()}`} className="link-underline block w-fit">{s.label}</a>
          ))}
        </Col>
      </div>
    </div>
    <div className="mx-auto mt-20 flex max-w-[1440px] flex-col gap-3 border-t border-cream/10 px-6 py-6 font-mono text-[11px] uppercase tracking-[0.2em] text-cream/50 md:flex-row md:justify-between md:px-10">
      <span>© {new Date().getFullYear()} Skaris Technology LLP</span>
      <span>IT Services · Digital Transformation · AI Transformation</span>
    </div>
    <motion.div
      className="mx-auto max-w-[1440px] px-6 pb-4 md:px-10"
      initial={{ y: "40%", opacity: 0.2 }}
      whileInView={{ y: "0%", opacity: 1 }}
      viewport={{ once: true, amount: 0.1 }}
      transition={{ duration: 1.4, ease: EASE }}
    >
      <Wordmark className="h-auto w-full text-skaris-navy" />
    </motion.div>
  </footer>
);
